
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"currentColor","fill-rule":"evenodd","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"nonzero","d":"M8.735 5.99v1.336h6.678V5.99H8.735m1.336 2.671v1.336h4.006V8.66h-4.006m-4.675.641v5.396L8.087 12l-2.69-2.698m13.375 0L16.08 12l2.69 2.698V9.302m-10.036 2.03v1.336h6.678v-1.336H8.735m1.336 2.671v1.336h4.006v-1.336h-4.006m-1.336 2.671v1.336h6.678v-1.336H8.735z"}}),_c('path',{attrs:{"d":"M12.084 1.833c5.566 0 10.084 4.518 10.084 10.083C22.168 17.482 17.65 22 12.084 22 6.52 22 2 17.482 2 11.916 2 6.351 6.519 1.833 12.084 1.833zm0 2.093c4.41 0 7.99 3.58 7.99 7.99s-3.58 7.99-7.99 7.99-7.99-3.58-7.99-7.99 3.58-7.99 7.99-7.99z"}})])
          )
        }
      }
    